import { ArrowBack } from "@mui/icons-material";
import { AppBar, Container, IconButton, Slide, Toolbar, Typography, useScrollTrigger } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// --- HIDE ON SCROLL UTILITY COMPONENT ---
// This is the key component that enables the auto-hide feature.
function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        // threshold:200
    });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
};
const TopBackBar = (props) => {
    const { title, to = "/" } = props;
    return (
        <HideOnScroll {...props}>
            <AppBar
                position="fixed"
                color="primary"
                sx={{ borderRadius: 0, marginTop: "56px", width: '100%', minHeight: "0px !important" }}

            >
                <Container maxWidth="lg">
                    <Toolbar disableGutters sx={{minHeight: "0px !important"}}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="back"
                            sx={{ mr: 2 }}
                            component={Link}
                            to={to}
                        >

                            <ArrowBack sx={{ color: "white" }} />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {title}
                        </Typography>
                    </Toolbar>
                </Container>
            </AppBar>
        </HideOnScroll>
    );
};

TopBackBar.propTypes = {
    title: PropTypes.string.isRequired, // Ensures title is a required string
    to: PropTypes.string, // Ensures 'to' is a string (default provided)
};

export default TopBackBar;
